import { gql, useMutation } from '@apollo/client'
import { currentMarketIdVar } from 'graphql/reactive'

const mutation = gql`
  mutation CreateProfileApplication(
    $marketId: ID!
    $input: ProfileApplicationInput!
  ) {
    market(id: $marketId) {
      createProfileApplication(input: $input) {
        result
        errors {
          identifier
          message
          field
        }
        profileApplication {
          id
          marketId
          email
          phone
          status
          instagram
          tiktok
          twitter
          youtube
        }
      }
    }
  }
`

export default function useCreateProfileApplication(useMutationArgs = {}) {
  const marketId = currentMarketIdVar()

  const [mutate, { loading }] = useMutation(mutation, useMutationArgs)

  const createProfileApplication = async (input) => {
    if (!input) throw new Error('input is required in createProfileApplication')
    await mutate({
      variables: {
        marketId,
        input,
      },
    })
  }

  return [createProfileApplication, { loading }]
}
